<template>
  <!-- Si el API todavía no tiene el reporte nuevo, se muestra el reporte de siempre. -->
  <div v-if="modoAnterior">
    <!-- La pantalla de reportes no pinta su renglón de título para este reporte: aquí se conserva la estrella. -->
    <div class="pp-fav-sola">
      <v-btn text small :color="esFavorito ? 'yellow' : 'grey'" :title="esFavorito ? T.favQuitar : T.favAgregar"
        @click="$emit('alternar-favorito')"><v-icon>mdi-star</v-icon></v-btn>
    </div>
    <MotivosParosNiveles :active="active" />
  </div>
  <div v-else class="pp-board" ref="board">
    <div class="pp-title-row">
      <div class="pp-title">{{ T.titulo }}</div>
      <v-btn class="pp-fav" text small :color="esFavorito ? 'yellow' : 'grey'" :title="esFavorito ? T.favQuitar : T.favAgregar"
        @click="$emit('alternar-favorito')"><v-icon>mdi-star</v-icon></v-btn>
    </div>
    <div class="pp-sub" v-if="resumenPeriodo">{{ resumenPeriodo }}</div>

    <!-- Filtros -->
    <div class="pp-toolbar">
      <div class="pp-filtros">
        <div class="pp-fecha">
          <VueCtkDateTimePicker v-model="filtros.inicio" :label="T.desde" format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm" noHeader :buttonNowTranslation="T.ahora" :min-date="fechaMinimaPicker"
            :max-date="filtros.fin" :disabled="loading" />
        </div>
        <div class="pp-fecha">
          <VueCtkDateTimePicker v-model="filtros.fin" :label="T.hasta" format="YYYY-MM-DD HH:mm"
            formatted="YYYY-MM-DD HH:mm" noHeader :buttonNowTranslation="T.ahora"
            :min-date="filtros.inicio || fechaMinimaPicker" :disabled="loading" />
        </div>
        <label class="pp-input pp-sel"><span class="k">{{ T.alcance }}</span>
          <select v-model="filtros.alcance" :disabled="loading">
            <option value="planta">{{ T.alcancePlanta }}</option>
            <option value="bahia">{{ T.alcanceBahia }}</option>
            <option value="maquinas">{{ T.alcanceMaquinas }}</option>
          </select>
        </label>
        <label class="pp-input pp-sel"><span class="k">{{ T.tiempo }}</span>
          <select v-model="filtros.soloLaborable" :disabled="loading">
            <option :value="true">{{ T.tiempoLaborable }}</option>
            <option :value="false">{{ T.tiempoReloj }}</option>
          </select>
        </label>
        <div class="pp-multi" v-if="filtros.alcance == 'bahia'">
          <v-autocomplete v-model="filtros.idsArea" :items="bahias" item-text="nombre" item-value="idArea"
            :label="T.bahias" multiple small-chips deletable-chips dense outlined hide-details attach
            :disabled="loading" />
        </div>
        <div class="pp-multi" v-if="filtros.alcance == 'maquinas'">
          <v-autocomplete v-model="filtros.idsMaquinaIns" :items="maquinasCatalogo" item-text="nombre"
            item-value="idMaquinaIns" :label="T.maquinas" multiple small-chips deletable-chips dense outlined
            hide-details attach :disabled="loading" />
        </div>
        <button class="pp-btn pp-btn-primary" @click="buscar()" :disabled="loading || cargandoAlcance">
          <v-icon small color="white">mdi-magnify</v-icon> {{ T.buscar }}
        </button>
      </div>
      <div class="pp-actions">
        <button class="pp-btn pp-btn-outline" @click="pantallaCompleta()">
          <v-icon small color="#2563d6">mdi-fullscreen</v-icon> {{ T.pantallaCompleta }}
        </button>
      </div>
    </div>
    <div class="pp-disponible" v-if="fechaMinima">{{ textoDisponibleDesde }}</div>

    <v-progress-linear v-if="loading || cargandoAlcance" indeterminate color="#2563d6" class="mt-3" />

    <!-- Mensajes de estado -->
    <div class="pp-aviso pp-aviso--error" v-if="mensajeError">{{ mensajeError }}</div>
    <div class="pp-aviso" v-if="mensajeValidacion">{{ mensajeValidacion }}</div>
    <div class="pp-aviso" v-if="estado == 'futuro'">{{ T.futuro }}</div>
    <div class="pp-aviso" v-if="estado == 'sinDatos'">{{ T.sinDatos }}</div>
    <div class="pp-aviso" v-if="hayDatos && sinHorario">{{ T.sinHorario }}</div>
    <div class="pp-aviso" v-if="hayDatos && hayParosFueraDeAlcance">{{ T.maquinasNoVisibles }}</div>

    <template v-if="hayDatos">
      <!-- Tarjetas resumen -->
      <div class="pp-toprow">
        <div class="pp-topcard pp-topcard--maq" :class="{ 'is-on': vista == 'maquina' }" role="button" tabindex="0"
          @click="alternarVista()" @keydown.enter.prevent="alternarVista()" @keydown.space.prevent="alternarVista()">
          <div class="pp-sec" style="flex:1 1 auto; min-width:0">
            <div class="pp-sec-head">
              <div class="pp-sec-title">{{ T.top3 }}</div>
              <span class="pp-card-hint">{{ vista == 'maquina' ? T.verPorCausa : T.verPorMaquina }}</span>
            </div>
            <div class="pp-top3">
              <div class="pp-t3" v-for="(r, i) in top3" :key="'t3' + r.id">
                <span class="pp-t3-rank">{{ i + 1 }}</span>
                <span class="pp-t3-h">{{ fmt(r.horas, 0) }}<small>h</small></span>
                <span class="pp-t3-n">
                  <span class="pp-t3-nom">{{ r.nombre }}</span>
                  <span class="pp-t3-sub">{{ r.bahia }} · {{ pctf(r.share) }} {{ T.delTotal }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="pp-topcard pp-topcard--paro">
          <div class="pp-sec">
            <div class="pp-sec-title">{{ T.tiempoTotal }}</div>
            <div class="pp-row-inline">
              <span class="pp-big">{{ fmt(horasIncluidas, 0) }} <small>h</small></span>
              <span class="pp-pct" :title="ayudaPctParo">{{ pctParo }}</span>
            </div>
          </div>
          <div class="pp-sec">
            <div class="pp-sec-title pp-sec-title--normal">{{ T.parosRegistrados }}</div>
            <span class="pp-big">{{ fmt(parosIncluidos, 0) }}</span>
          </div>
          <div class="pp-sec">
            <div class="pp-sec-title pp-sec-title--normal">{{ T.causas80 }}</div>
            <span class="pp-big">{{ paretoCausaHoras.n80 }} {{ T.de }} {{ paretoCausaHoras.n }}</span>
          </div>
          <div class="pp-sec">
            <div class="pp-sec-title pp-sec-title--normal">{{ T.maquinas80 }}</div>
            <span class="pp-big">{{ paretoMaquinaHoras.n80 }} {{ T.de }} {{ maquinasIncluidas }}</span>
          </div>
        </div>
      </div>

      <div class="pp-legend">
        <span class="pp-lg"><i class="sw-bar"></i> {{ T.leyendaDentro }}</span>
        <span class="pp-lg"><i class="sw-soft"></i> {{ T.leyendaResto }}</span>
        <span class="pp-lg"><i class="sw-line"></i> {{ T.leyendaAcum }}</span>
        <span class="pp-lg"><i class="sw-guide"></i> {{ T.leyendaCorte }}</span>
      </div>

      <!-- Barra de exclusiones -->
      <div class="pp-excl-bar" v-if="chipsExcluidos.length">
        <span class="pp-excl-lbl">{{ T.excluidas }}</span>
        <button class="pp-chip pp-chip--excl" v-for="c in chipsExcluidos" :key="c.dim + c.id"
          @click="conmuta(c.dim, c.id)">{{ c.nombre }} <span class="x">×</span></button>
        <button class="pp-excl-reset" @click="restablecer()">{{ T.restablecer }}</button>
      </div>

      <!-- Pareto (por causa o por máquina) -->
      <section class="pp-pareto">
        <div class="pp-pareto-head">
          <div class="pp-seg" role="group">
            <button :aria-pressed="String(vista == 'causa')" @click="vista = 'causa'">{{ T.porCausa }}</button>
            <button :aria-pressed="String(vista == 'maquina')" @click="vista = 'maquina'">{{ T.porMaquina }}</button>
          </div>
          <span class="pp-hint">{{ vista == 'causa' ? T.hintCausa : T.hintMaquina }}</span>
          <div class="pp-seg pp-seg--medida" role="group">
            <button :aria-pressed="String(medida[vista] == 'horas')" @click="medida[vista] = 'horas'">{{ T.medidaHoras }}</button>
            <button :aria-pressed="String(medida[vista] == 'paros')" @click="medida[vista] = 'paros'">{{ T.medidaParos }}</button>
          </div>
        </div>
        <div class="pp-pareto-body">
          <div class="pp-tbl-wrap">
            <table>
              <thead>
                <tr>
                  <th>#</th>
                  <th class="l">{{ vista == 'causa' ? T.colCausa : T.colMaquina }}</th>
                  <th class="l" v-if="vista == 'maquina'">{{ T.colBahia }}</th>
                  <th>{{ T.colParos }}</th>
                  <th>{{ T.colHoras }}</th>
                  <th>{{ T.colPct }}</th>
                  <th>{{ T.colAcum }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(r, i) in paretoVista.rows" :key="'r' + r.id"
                  :class="{ in80: r.in80, otras: r.otras, conmuta: !r.otras, 'is-hot': hot === i }"
                  :tabindex="r.otras ? -1 : 0" @mouseenter="hot = i" @mouseleave="hot = null"
                  @click="!r.otras && conmuta(vista, r.id)" @keydown.enter.prevent="!r.otras && conmuta(vista, r.id)"
                  @keydown.space.prevent="!r.otras && conmuta(vista, r.id)">
                  <td class="rank">{{ r.otras ? '—' : i + 1 }}</td>
                  <td class="l name"><span class="chk" :class="r.otras ? 'chk--na' : 'chk--on'"></span>{{ r.nombre }}</td>
                  <td class="l" v-if="vista == 'maquina'">{{ r.bahia }}</td>
                  <td>{{ fmt(r.paros, 0) }}</td>
                  <td>{{ fmt(r.horas, 1) }}</td>
                  <td>{{ pctf(r.share) }}</td>
                  <td class="acc">{{ pctf(r.acum) }}</td>
                </tr>
                <tr class="sep" v-if="excluidasVista.length">
                  <td :colspan="vista == 'maquina' ? 7 : 6">{{ T.excluidasSep }}</td>
                </tr>
                <tr class="excl conmuta" v-for="r in excluidasVista" :key="'x' + r.id" tabindex="0"
                  @click="conmuta(vista, r.id)" @keydown.enter.prevent="conmuta(vista, r.id)"
                  @keydown.space.prevent="conmuta(vista, r.id)">
                  <td class="rank">✕</td>
                  <td class="l name"><span class="chk chk--off"></span>{{ r.nombre }}</td>
                  <td class="l" v-if="vista == 'maquina'">{{ r.bahia }}</td>
                  <td>{{ fmt(r.paros, 0) }}</td>
                  <td>{{ fmt(r.horas, 1) }}</td>
                  <td>—</td>
                  <td class="acc">—</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td></td>
                  <td class="l">{{ excluidasVista.length ? T.totalSinExcluidas : T.total }}</td>
                  <td v-if="vista == 'maquina'"></td>
                  <td>{{ fmt(totalVista.paros, 0) }}</td>
                  <td>{{ fmt(totalVista.horas, 1) }}</td>
                  <td>100 %</td>
                  <td></td>
                </tr>
              </tfoot>
            </table>
          </div>
          <div class="pp-chart-wrap">
            <svg :viewBox="`0 0 ${G.W} ${G.H}`" role="img" :aria-label="T.ariaGrafica">
              <g v-for="t in G.ticks" :key="'tk' + t">
                <line class="ax" :x1="G.l" :x2="G.W - G.r" :y1="gy(t)" :y2="gy(t)" />
                <text class="ax-lbl" :x="G.l - 6" :y="gy(t) + 4" text-anchor="end">{{ Math.round(t * 100) }}%</text>
              </g>
              <line class="guide" :x1="G.l" :x2="G.W - G.r" :y1="gy(0.8)" :y2="gy(0.8)" />
              <text class="guide-lbl" :x="G.W - G.r" :y="gy(0.8) - 5" text-anchor="end">80 %</text>
              <g v-for="(r, i) in paretoVista.rows" :key="'b' + r.id">
                <rect class="bar-rect" :class="{ soft: !r.in80, otras: r.otras, 'is-hot': hot === i }"
                  :x="gx(i) - anchoBarra / 2" :y="gy(r.share)" :width="anchoBarra"
                  :height="Math.max(0, r.share * G.ih)" :rx="Math.min(3, anchoBarra / 2)" />
                <text class="ax-lbl" :x="gx(i)" :y="G.H - G.b + 16" text-anchor="middle">{{ r.otras ? T.otrasCorto : i + 1 }}</text>
              </g>
              <polyline class="cum" :points="puntosAcumulado" />
              <circle class="cum-dot" v-for="(r, i) in paretoVista.rows" :key="'c' + r.id" :cx="gx(i)"
                :cy="gy(r.acum)" r="3.2" />
              <rect class="hit" v-for="(r, i) in paretoVista.rows" :key="'h' + r.id" :x="G.l + ranura * i"
                :y="G.t" :width="ranura" :height="G.ih" @mouseenter="entraBarra(i, $event)"
                @mousemove="mueveTip($event)" @mouseleave="saleBarra()" @click="clicBarra(r)" />
              <text class="ax-lbl" :x="G.l + G.iw / 2" :y="G.H - 3" text-anchor="middle">{{ T.ejeX }}</text>
            </svg>
          </div>
        </div>
        <div class="pp-pareto-foot">{{ vista == 'causa' ? textoPie : T.pieMaquina }}</div>
      </section>
    </template>

    <!-- Paros abiertos: no suman, se listan aparte -->
    <details class="pp-abiertos" v-if="(hayDatos || estado == 'sinDatos') && abiertos.length">
      <summary><span class="ab-n">{{ abiertos.length }}</span> {{ abiertos.length == 1 ? T.abiertosUno : T.abiertosVarios }}<span
          class="ab-ver">{{ T.verLista }}</span></summary>
      <div class="pp-tbl-wrap">
        <table>
          <thead>
            <tr>
              <th class="l">{{ T.colMaquina }}</th>
              <th class="l">{{ T.colBahia }}</th>
              <th class="l">{{ T.colCausa }}</th>
              <th class="l">{{ T.abiertoDesde }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(a, i) in abiertos" :key="'a' + i">
              <td class="l">{{ a.maquina }}</td>
              <td class="l">{{ a.area }}</td>
              <td class="l">{{ a.causa }}</td>
              <td class="l">{{ a.desde }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </details>

    <!-- Tooltip propio: vive dentro del tablero para que también se vea en pantalla completa -->
    <div class="pp-tip" v-if="tip.visible" :style="{ left: tip.x + 'px', top: tip.y + 'px' }">
      <b>{{ tip.titulo }}</b><span class="m" v-if="tip.bahia"> · {{ tip.bahia }}</span><br>
      {{ tip.linea1 }}<br>
      <span class="m">{{ tip.linea2 }}</span>
      <span class="m" v-if="tip.excluible"><br>{{ T.clicExcluir }}</span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import MotivosParosNiveles from '../Proyeccion/MotivosParosNiveles.vue';

// ===== Decisiones de presentación fáciles de cambiar (un solo lugar) =====
// Cuando el periodo incluye paros de máquinas que ya no están visibles, el «% de paro» se pinta «—»
// (el denominador contaría máquinas que todavía no existían). Poner false para pintarlo de todos modos.
const PCT_PARO_GUION_CON_MAQUINAS_NO_VISIBLES = true;
// Renglones del Pareto antes de agrupar el resto en «Otras».
const RENGLONES_PARETO = 10;
// Días del periodo por omisión al abrir el reporte.
const DIAS_POR_OMISION = 30;
// El tope máximo del periodo NO vive aquí: lo manda el API en la respuesta de Alcance.

// ===== Textos: todos aquí, en español =====
const TEXTOS = {
  titulo: 'Pareto de paros por causa y por máquina',
  favAgregar: 'Agregar a favoritos', favQuitar: 'Quitar de favoritos',
  desde: 'Desde', hasta: 'Hasta', ahora: 'Ahora', buscar: 'Buscar', pantallaCompleta: 'Pantalla completa',
  alcance: 'Alcance:', alcancePlanta: 'Toda la planta', alcanceBahia: 'Por bahía', alcanceMaquinas: 'Máquinas',
  tiempo: 'Tiempo:', tiempoLaborable: 'Sólo laborable de la planta', tiempoReloj: 'De reloj (24 h)',
  bahias: 'Bahías', maquinas: 'Máquinas',
  disponibleDesde: 'Disponible desde el {fecha}.',
  top3: 'Las 3 máquinas con más tiempo de paro',
  verPorMaquina: 'Ver Pareto por máquina ›', verPorCausa: 'Volver al Pareto por causa ›',
  delTotal: 'del total', de: 'de',
  tiempoTotal: 'Tiempo total de paro', parosRegistrados: 'Paros registrados',
  causas80: 'Causas para el 80 %', maquinas80: 'Máquinas para el 80 %',
  ayudaLaborable: 'Horas de paro entre el tiempo laborable disponible: {h} h de horario de planta × {n} máquinas = {H} h',
  ayudaReloj: 'Horas de paro entre el tiempo disponible: {h} h del periodo × {n} máquinas = {H} h',
  ayudaSinPct: 'El porcentaje no se muestra en este periodo.',
  leyendaDentro: 'Dentro del 80 % acumulado', leyendaResto: 'Resto', leyendaAcum: '% acumulado', leyendaCorte: 'Corte del 80 %',
  excluidas: 'Excluidas del Pareto:', restablecer: 'Restablecer todo',
  excluidasSep: 'Excluidas del Pareto · clic para volver a incluir',
  porCausa: 'Por causa', porMaquina: 'Por máquina',
  hintCausa: 'Las primeras 10 causas · clic en un renglón o en su barra para excluirlo y recalcular',
  hintMaquina: 'Las primeras 10 máquinas · clic en un renglón o en su barra para excluirlo y recalcular',
  medidaHoras: 'Horas de paro', medidaParos: 'Número de paros',
  colCausa: 'Causa', colMaquina: 'Máquina', colBahia: 'Bahía', colParos: 'Paros', colHoras: 'Horas',
  colPct: '% del total', colAcum: '% acum.',
  total: 'Total', totalSinExcluidas: 'Total sin excluidas',
  otrasCausas: 'Otras ({n} causas)', otrasMaquinas: 'Otras ({n} máquinas)', otrasCorto: 'Otras',
  sinMaquina: 'Sin máquina asignada',
  ejeX: 'Nº de fila en la tabla', ariaGrafica: 'Pareto: barras = % del total; línea = % acumulado',
  clicExcluir: 'Clic para excluir', tipHoras: '{h} h · {p} paros', tipPct: '{a} del total · {b} acumulado',
  pieLaborable: 'Ordenado por la medida elegida, de mayor a menor. Las horas se recortan al horario de planta (Recursos humanos › Horarios: {horario}) y a la ventana de fechas: un paro aporta sólo los minutos que caen dentro de las dos, y cuenta como paro si toca el horario aunque haya iniciado fuera. Los paros que siguen abiertos no suman y se listan abajo. El porcentaje junto a las horas es el tiempo de paro entre el tiempo laborable disponible (horas del horario de planta en el periodo por las máquinas incluidas).',
  pieReloj: 'Ordenado por la medida elegida, de mayor a menor. Las horas son de reloj (24 h) y se recortan a la ventana de fechas: un paro aporta sólo los minutos que caen dentro de ella. Los paros que siguen abiertos no suman y se listan abajo. El porcentaje junto a las horas es el tiempo de paro entre el tiempo disponible (horas del periodo por las máquinas incluidas).',
  pieMaquina: 'Al filtrar por bahía o por máquinas, las dos tablas y las dos gráficas se recalculan sobre ese conjunto.',
  abiertosUno: 'paro sigue abierto y no suma en este reporte.', abiertosVarios: 'paros siguen abiertos y no suman en este reporte.',
  verLista: 'Ver lista', abiertoDesde: 'Abierto desde',
  sinHorario: 'Esta planta no tiene un horario configurado en Recursos humanos › Horarios. El tiempo se muestra de reloj (24 h).',
  maquinasNoVisibles: 'Este periodo incluye paros de máquinas que ya no están visibles en la plataforma; no forman parte de este reporte.',
  sinDatos: 'No hay paros registrados en este periodo con los filtros elegidos.',
  futuro: 'El periodo elegido todavía no comienza.',
  error: 'No se pudo consultar el reporte. Intenta de nuevo en unos minutos.',
  tope: 'El periodo máximo es de {n} meses.',
  faltanFechas: 'Elige la fecha inicial y la fecha final del periodo.',
  fechasInvertidas: 'La fecha final debe ser posterior a la fecha inicial.',
  resumen: 'Del {a} al {b} · {alcance} · {tiempo}',
  resumenLaborable: 'sólo tiempo laborable de la planta', resumenReloj: 'tiempo de reloj (24 h)',
  resumenBahias: '{n} bahías', resumenUnaBahia: '1 bahía', resumenMaquinas: '{n} máquinas', resumenUnaMaquina: '1 máquina',
  dias: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  meses: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
};

// El API puede contestar las llaves con minúscula o con mayúscula inicial: se aceptan las dos.
function val(o, campo) {
  if (o == null) return undefined;
  if (o[campo] !== undefined) return o[campo];
  return o[campo.charAt(0).toUpperCase() + campo.slice(1)];
}

function dos(n) { return String(n).padStart(2, '0'); }

// "2026-04-20T00:00:00" o "2026-04-20 00:00" -> partes numéricas, sin pasar por zonas horarias.
function partesFecha(texto) {
  const m = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2})/.exec(String(texto || ''));
  if (!m) return null;
  return { a: +m[1], m: +m[2], d: +m[3], h: +m[4], mi: +m[5] };
}

export default {
  components: { MotivosParosNiveles },
  props: ['active', 'esFavorito'],
  data() {
    return {
      T: TEXTOS,
      modoAnterior: false,
      cargandoAlcance: true,
      loading: false,
      mensajeError: null,
      mensajeValidacion: null,
      estado: null, // null | 'datos' | 'sinDatos' | 'futuro'
      maquinasCatalogo: [],
      fechaMinima: null,
      diasMaximosVentana: null,
      filtros: { inicio: null, fin: null, alcance: 'planta', soloLaborable: true, idsArea: [], idsMaquinaIns: [] },
      consultado: null, // los filtros con los que se hizo la última consulta, para el resumen
      respuesta: null,
      vista: 'causa',
      medida: { causa: 'horas', maquina: 'horas' },
      excl: { causa: [], maquina: [] },
      hot: null,
      tip: { visible: false, x: 0, y: 0, titulo: '', bahia: '', linea1: '', linea2: '', excluible: false },
      G: { W: 640, H: 300, t: 14, r: 16, b: 34, l: 40, iw: 640 - 40 - 16, ih: 300 - 14 - 34, ticks: [0, 0.2, 0.4, 0.6, 0.8, 1] },
    };
  },
  computed: {
    hayDatos() { return this.estado == 'datos'; },
    bahias() {
      const vistas = {};
      const lista = [];
      this.maquinasCatalogo.forEach(a => {
        if (vistas[a.idArea]) return;
        vistas[a.idArea] = true;
        lista.push({ idArea: a.idArea, nombre: a.area });
      });
      return lista.sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es'));
    },
    fechaMinimaPicker() {
      const p = partesFecha(this.fechaMinima);
      return p ? `${p.a}-${dos(p.m)}-${dos(p.d)} ${dos(p.h)}:${dos(p.mi)}` : null;
    },
    textoDisponibleDesde() {
      return this.T.disponibleDesde.replace('{fecha}', this.fechaCorta(this.fechaMinima, false));
    },
    sinHorario() { return !!val(this.respuesta, 'sinHorario'); },
    hayParosFueraDeAlcance() { return !!val(this.respuesta, 'hayParosFueraDeAlcance'); },
    soloLaborableAplicado() { return !!val(this.respuesta, 'soloLaborable'); },
    segundosBase() { return Number(val(this.respuesta, 'segundosBaseVentana') || 0); },
    maquinasAlcance() {
      return (val(this.respuesta, 'maquinas') || []).map(a => ({
        id: val(a, 'idMaquinaIns'), nombre: val(a, 'nombre'), bahia: val(a, 'area') || '',
      }));
    },
    nombresMaquina() {
      const m = { 0: { nombre: this.T.sinMaquina, bahia: '' } };
      this.maquinasAlcance.forEach(a => { m[a.id] = a; });
      return m;
    },
    nombresCausa() {
      const m = {};
      (val(this.respuesta, 'causas') || []).forEach(a => { m[val(a, 'idParoTipo')] = val(a, 'nombre'); });
      return m;
    },
    celdas() {
      return (val(this.respuesta, 'celdas') || []).map(a => ({
        causa: val(a, 'idParoTipo'), maquina: val(a, 'idMaquinaIns'),
        paros: Number(val(a, 'paros') || 0), segundos: Number(val(a, 'segundos') || 0),
      }));
    },
    abiertos() {
      return (val(this.respuesta, 'abiertos') || []).map(a => ({
        maquina: val(a, 'maquina'), area: val(a, 'area'), causa: val(a, 'causa'),
        desde: this.fechaLarga(val(a, 'desde')),
      }));
    },
    // Pareto de la vista activa, con la medida elegida en esa vista.
    paretoVista() { return this.pareto(this.agrupa(this.vista, false), this.medida[this.vista], this.vista); },
    // Las tarjetas siempre se calculan en horas, sobre lo incluido.
    paretoCausaHoras() { return this.pareto(this.agrupa('causa', false), 'horas', 'causa'); },
    paretoMaquinaHoras() { return this.pareto(this.agrupa('maquina', false), 'horas', 'maquina'); },
    top3() { return this.paretoMaquinaHoras.rows.filter(r => !r.otras).slice(0, 3); },
    excluidasVista() {
      const dim = this.vista;
      return this.agrupa(dim, true).filter(r => this.excl[dim].indexOf(r.id) >= 0).sort((a, b) => b.segundos - a.segundos);
    },
    totalVista() {
      return {
        paros: this.paretoVista.rows.reduce((s, r) => s + r.paros, 0),
        horas: this.paretoVista.rows.reduce((s, r) => s + r.horas, 0),
      };
    },
    celdasIncluidas() {
      return this.celdas.filter(c => this.excl.causa.indexOf(c.causa) < 0 && this.excl.maquina.indexOf(c.maquina) < 0);
    },
    horasIncluidas() { return this.celdasIncluidas.reduce((s, c) => s + c.segundos, 0) / 3600; },
    parosIncluidos() { return this.celdasIncluidas.reduce((s, c) => s + c.paros, 0); },
    // Máquinas del alcance que no están excluidas, hayan tenido paro o no. «Sin máquina asignada» no cuenta como máquina.
    maquinasIncluidas() {
      return this.maquinasAlcance.filter(a => this.excl.maquina.indexOf(a.id) < 0).length;
    },
    segundosDisponibles() { return this.segundosBase * this.maquinasIncluidas; },
    pctParoOculto() { return PCT_PARO_GUION_CON_MAQUINAS_NO_VISIBLES && this.hayParosFueraDeAlcance; },
    pctParo() {
      if (this.pctParoOculto || !this.segundosDisponibles) return '—';
      // Los paros sin máquina asignada no entran al porcentaje: no tienen máquina en el denominador.
      const seg = this.celdasIncluidas.filter(c => c.maquina !== 0).reduce((s, c) => s + c.segundos, 0);
      return this.pctf(seg / this.segundosDisponibles);
    },
    ayudaPctParo() {
      if (this.pctParoOculto || !this.segundosDisponibles) return this.T.ayudaSinPct;
      const h = this.segundosBase / 3600;
      return (this.soloLaborableAplicado ? this.T.ayudaLaborable : this.T.ayudaReloj)
        .replace('{h}', this.fmt(h, 0)).replace('{n}', this.maquinasIncluidas)
        .replace('{H}', this.fmt(h * this.maquinasIncluidas, 0));
    },
    chipsExcluidos() {
      const c = this.excl.causa.map(id => ({ dim: 'causa', id, nombre: this.nombresCausa[id] }));
      const m = this.excl.maquina.map(id => ({ dim: 'maquina', id, nombre: (this.nombresMaquina[id] || {}).nombre }));
      return c.concat(m);
    },
    textoHorario() {
      // Agrupa los días que comparten el mismo horario: «lunes a viernes 07:00 a 23:59 y lunes a sábado 00:00 a 02:30».
      const grupos = [];
      (val(this.respuesta, 'horario') || []).forEach(a => {
        const k = `${val(a, 'inicio')} a ${val(a, 'fin')}`;
        let g = grupos.find(x => x.k == k);
        if (!g) { g = { k, inicio: val(a, 'inicio'), dias: [] }; grupos.push(g); }
        const d = Number(val(a, 'diaSemana'));
        if (g.dias.indexOf(d) < 0) g.dias.push(d);
      });
      // Primero el horario que empieza más tarde en el día (el turno principal), como lo lee la planta.
      grupos.sort((a, b) => String(b.inicio).localeCompare(String(a.inicio)));
      return this.unir(grupos.map(g => `${this.textoDias(g.dias)} ${g.k}`));
    },
    textoPie() {
      if (!this.soloLaborableAplicado) return this.T.pieReloj;
      return this.T.pieLaborable.replace('{horario}', this.textoHorario);
    },
    resumenPeriodo() {
      // Sólo se describe el periodo cuando hay un periodo consultado de verdad (no si todavía no comienza o es anterior a la fecha mínima).
      if (!this.respuesta || !this.consultado || this.estado == 'futuro' || val(this.respuesta, 'antesDeFechaMinima')) return null;
      const c = this.consultado;
      let alcance = this.T.alcancePlanta.toLowerCase();
      if (c.alcance == 'bahia' && c.idsArea.length) alcance = c.idsArea.length == 1 ? this.T.resumenUnaBahia : this.T.resumenBahias.replace('{n}', c.idsArea.length);
      if (c.alcance == 'maquinas' && c.idsMaquinaIns.length) alcance = c.idsMaquinaIns.length == 1 ? this.T.resumenUnaMaquina : this.T.resumenMaquinas.replace('{n}', c.idsMaquinaIns.length);
      return this.T.resumen
        .replace('{a}', this.fechaCorta(val(this.respuesta, 'inicio'), true))
        .replace('{b}', this.fechaCorta(val(this.respuesta, 'finEfectivo'), true))
        .replace('{alcance}', alcance)
        .replace('{tiempo}', this.soloLaborableAplicado ? this.T.resumenLaborable : this.T.resumenReloj);
    },
    // Geometría de la gráfica
    ranura() { return this.G.iw / Math.max(1, this.paretoVista.rows.length); },
    anchoBarra() { return Math.min(54, Math.max(6, this.ranura * 0.62)); },
    puntosAcumulado() { return this.paretoVista.rows.map((r, i) => `${this.gx(i)},${this.gy(r.acum)}`).join(' '); },
  },
  watch: {
    // Cambiar entre tiempo laborable y de reloj vuelve a consultar: los segundos los calcula el API, nunca el navegador.
    'filtros.soloLaborable'() {
      if (this.respuesta) this.buscar();
    },
  },
  mounted() {
    this.fechasPorOmision();
    this.getAlcance();
  },
  methods: {
    // ===== Llamadas al API =====
    getAlcance() {
      this.cargandoAlcance = true;
      axios
        .get("/ReportesParos/Alcance")
        .then(response => {
          const data = response.data || {};
          this.maquinasCatalogo = (val(data, 'maquinas') || []).map(a => ({
            idMaquinaIns: val(a, 'idMaquinaIns'), nombre: val(a, 'nombre'), idArea: val(a, 'idArea'), area: val(a, 'area'),
          }));
          this.fechaMinima = val(data, 'fechaMinima') || null;
          this.diasMaximosVentana = val(data, 'diasMaximosVentana') || null;
          this.fechasPorOmision();
          this.cargandoAlcance = false;
          this.buscar();
        })
        .catch(error => {
          this.cargandoAlcance = false;
          this.atiendeError(error);
        });
    },
    buscar() {
      if (this.cargandoAlcance || this.loading) return;
      this.mensajeError = null;
      this.mensajeValidacion = this.validaFiltros();
      if (this.mensajeValidacion) return;

      const f = this.filtros;
      const consulta = {
        Inicio: this.aIso(f.inicio),
        Fin: this.aIso(f.fin),
        IdsArea: f.alcance == 'bahia' ? f.idsArea : [],
        IdsMaquinaIns: f.alcance == 'maquinas' ? f.idsMaquinaIns : [],
        SoloLaborable: f.soloLaborable,
      };
      this.loading = true;
      axios
        .post("/ReportesParos/Pareto", consulta)
        .then(response => {
          this.recibe(response.data || {}, { alcance: f.alcance, idsArea: consulta.IdsArea.slice(), idsMaquinaIns: consulta.IdsMaquinaIns.slice() });
        })
        .catch(error => {
          this.atiendeError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    recibe(data, consultado) {
      this.respuesta = data;
      this.consultado = consultado;
      this.tip.visible = false;
      this.hot = null;

      // Si el servidor subió el inicio a la fecha mínima, el filtro muestra el inicio efectivo.
      const ini = partesFecha(val(data, 'inicio'));
      if (ini && !val(data, 'antesDeFechaMinima')) {
        const efectivo = `${ini.a}-${dos(ini.m)}-${dos(ini.d)} ${dos(ini.h)}:${dos(ini.mi)}`;
        if (this.filtros.inicio && efectivo > this.filtros.inicio) this.filtros.inicio = efectivo;
      }

      const celdas = val(data, 'celdas') || [];
      if (val(data, 'antesDeFechaMinima')) this.estado = 'sinDatos';
      else if (String(val(data, 'finEfectivo')) <= String(val(data, 'inicio'))) this.estado = 'futuro';
      else if (!celdas.length) this.estado = 'sinDatos';
      else this.estado = 'datos';

      // Se conservan sólo las exclusiones que siguen existiendo; si dejarían el Pareto vacío, se quitan.
      this.excl.causa = this.excl.causa.filter(id => this.celdas.some(c => c.causa === id));
      this.excl.maquina = this.excl.maquina.filter(id => this.celdas.some(c => c.maquina === id));
      if (this.estado == 'datos' && !this.celdasIncluidas.length) this.restablecer();
    },
    // El error puede llegar SIN respuesta (sin red, el interceptor global truena antes): no se supone error.response.
    // Nunca se pinta el mensaje que mande el API.
    atiendeError(error) {
      const respuesta = error && error.response ? error.response : null;
      const codigo = respuesta ? respuesta.status : null;
      if (codigo === 404 || codigo === 405) {
        // El API de esta planta todavía no tiene el reporte nuevo: se muestra el de siempre.
        this.modoAnterior = true;
        return;
      }
      console.log('Pareto de paros: no se pudo consultar', codigo);
      this.mensajeError = this.T.error;
    },
    validaFiltros() {
      const a = partesFecha(this.filtros.inicio), b = partesFecha(this.filtros.fin);
      if (!a || !b) return this.T.faltanFechas;
      if (this.filtros.fin <= this.filtros.inicio) return this.T.fechasInvertidas;
      if (this.diasMaximosVentana) {
        const dias = (Date.UTC(b.a, b.m - 1, b.d, b.h, b.mi) - Date.UTC(a.a, a.m - 1, a.d, a.h, a.mi)) / 86400000;
        if (dias > this.diasMaximosVentana) return this.T.tope.replace('{n}', Math.floor(this.diasMaximosVentana / 30));
      }
      return null;
    },

    // ===== Cálculo del Pareto (todo en el navegador, sobre el cruce causa por máquina) =====
    // Agrupa las celdas por la dimensión pedida. Las exclusiones de las DOS dimensiones aplican siempre;
    // con ignorarPropia se ignoran las de la propia dimensión (para listar las excluidas con sus cifras).
    agrupa(dim, ignorarPropia) {
      const m = {};
      const orden = [];
      this.celdas.forEach(c => {
        const exC = this.excl.causa.indexOf(c.causa) >= 0, exM = this.excl.maquina.indexOf(c.maquina) >= 0;
        if (dim == 'causa' ? (exM || (!ignorarPropia && exC)) : (exC || (!ignorarPropia && exM))) return;
        const id = dim == 'causa' ? c.causa : c.maquina;
        if (!m[id]) {
          const maq = this.nombresMaquina[id] || {};
          m[id] = {
            id, nombre: dim == 'causa' ? this.nombresCausa[id] : maq.nombre,
            bahia: dim == 'maquina' ? (maq.bahia || '') : '', paros: 0, segundos: 0, horas: 0,
          };
          orden.push(id);
        }
        m[id].paros += c.paros;
        m[id].segundos += c.segundos;
      });
      return orden.map(id => { m[id].horas = m[id].segundos / 3600; return m[id]; });
    },
    pareto(items, medida, dim) {
      const campo = medida == 'horas' ? 'segundos' : 'paros';
      let rows = items.slice().sort((a, b) => b[campo] - a[campo] || String(a.nombre).localeCompare(String(b.nombre), 'es'));
      const total = rows.reduce((s, r) => s + r[campo], 0);
      const n = rows.length;
      let acc = 0, n80 = 0, marcado = false;
      rows.forEach((r, i) => {
        r.share = total ? r[campo] / total : 0;
        acc += r.share;
        r.acum = acc;
        r.in80 = !marcado;
        if (!marcado) { n80 = i + 1; if (acc >= 0.8 - 1e-12) marcado = true; }
      });
      if (rows.length > RENGLONES_PARETO) {
        const resto = rows.slice(RENGLONES_PARETO);
        const o = {
          id: 'otras', otras: true, bahia: '', in80: false, acum: 1,
          nombre: (dim == 'causa' ? this.T.otrasCausas : this.T.otrasMaquinas).replace('{n}', resto.length),
          paros: resto.reduce((s, r) => s + r.paros, 0), segundos: resto.reduce((s, r) => s + r.segundos, 0),
        };
        o.horas = o.segundos / 3600;
        o.share = total ? o[campo] / total : 0;
        rows = rows.slice(0, RENGLONES_PARETO).concat([o]);
      }
      return { rows, total, n80, n };
    },
    conmuta(dim, id) {
      const lista = this.excl[dim];
      const i = lista.indexOf(id);
      if (i >= 0) lista.splice(i, 1);
      else {
        // Nunca se queda el Pareto vacío.
        if (this.agrupa(dim, false).length <= 1) return;
        lista.push(id);
      }
      this.tip.visible = false;
      this.hot = null;
    },
    restablecer() {
      this.excl.causa = [];
      this.excl.maquina = [];
    },
    alternarVista() { this.vista = this.vista == 'causa' ? 'maquina' : 'causa'; },

    // ===== Gráfica =====
    gy(v) { return this.G.t + this.G.ih - v * this.G.ih; },
    gx(i) { return this.G.l + this.ranura * i + this.ranura / 2; },
    entraBarra(i, evento) {
      const r = this.paretoVista.rows[i];
      if (!r) return;
      this.hot = i;
      this.tip.titulo = (r.otras ? '' : (i + 1) + '. ') + r.nombre;
      this.tip.bahia = r.bahia;
      this.tip.linea1 = this.T.tipHoras.replace('{h}', this.fmt(r.horas, 1)).replace('{p}', this.fmt(r.paros, 0));
      this.tip.linea2 = this.T.tipPct.replace('{a}', this.pctf(r.share)).replace('{b}', this.pctf(r.acum));
      this.tip.excluible = !r.otras;
      this.tip.visible = true;
      this.mueveTip(evento);
    },
    mueveTip(evento) {
      this.tip.x = Math.min(evento.clientX + 12, window.innerWidth - 280);
      this.tip.y = evento.clientY + 14;
    },
    saleBarra() { this.hot = null; this.tip.visible = false; },
    clicBarra(r) { if (!r.otras) this.conmuta(this.vista, r.id); },
    pantallaCompleta() {
      const el = this.$refs.board;
      if (!el) return;
      if (!document.fullscreenElement) {
        if (el.requestFullscreen) el.requestFullscreen();
      } else if (document.exitFullscreen) document.exitFullscreen();
    },

    // ===== Fechas y formatos =====
    fechasPorOmision() {
      const ahora = new Date();
      const hace = new Date(ahora.getTime() - DIAS_POR_OMISION * 86400000);
      const texto = d => `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())} ${dos(d.getHours())}:${dos(d.getMinutes())}`;
      let inicio = texto(hace);
      if (this.fechaMinimaPicker && inicio < this.fechaMinimaPicker) inicio = this.fechaMinimaPicker;
      this.filtros.inicio = inicio;
      this.filtros.fin = texto(ahora);
    },
    aIso(texto) {
      const p = partesFecha(texto);
      return p ? `${p.a}-${dos(p.m)}-${dos(p.d)}T${dos(p.h)}:${dos(p.mi)}:00` : null;
    },
    // 20-abr-2026 (con hora sólo si se pide o si no es medianoche)
    fechaCorta(texto, conHora) {
      const p = partesFecha(texto);
      if (!p) return '';
      const dia = `${dos(p.d)}-${this.T.meses[p.m - 1]}-${p.a}`;
      return (conHora || p.h || p.mi) ? `${dia} ${dos(p.h)}:${dos(p.mi)}` : dia;
    },
    fechaLarga(texto) {
      const p = partesFecha(texto);
      return p ? `${p.a}-${dos(p.m)}-${dos(p.d)} ${dos(p.h)}:${dos(p.mi)}` : '';
    },
    // Días de la semana en texto, de lunes a domingo, juntando los consecutivos: «lunes a viernes».
    textoDias(dias) {
      const orden = [1, 2, 3, 4, 5, 6, 0].filter(d => dias.indexOf(d) >= 0);
      const pos = d => (d + 6) % 7;
      const tramos = [];
      orden.forEach(d => {
        const u = tramos[tramos.length - 1];
        if (u && pos(u[u.length - 1]) + 1 == pos(d)) u.push(d);
        else tramos.push([d]);
      });
      return this.unir(tramos.map(t => t.length >= 3 ? `${this.T.dias[t[0]]} a ${this.T.dias[t[t.length - 1]]}` : this.unir(t.map(d => this.T.dias[d]))));
    },
    unir(partes) {
      if (partes.length <= 1) return partes.join('');
      return partes.slice(0, -1).join(', ') + ' y ' + partes[partes.length - 1];
    },
    fmt(n, d) { return Number(n || 0).toLocaleString('es-MX', { minimumFractionDigits: d, maximumFractionDigits: d }); },
    pctf(n) { return (Number(n || 0) * 100).toFixed(1).replace('.', ',') + ' %'; },
  },
};
</script>

<style scoped>
/* Estilos del formato aprobado del reporte, autocontenidos en el componente. */
.pp-board {
  --ink: #283139; --muted: #6b7682; --muted-2: #657993; --line: #e6e9ed; --blue: #2563d6; --kpi: #2d84da;
  --bar: #2d84da; --bar-soft: #bcd5f1; --guide: #d64545;
  position: relative; max-width: 1440px; margin: 0 auto; background: #fff; color: var(--ink);
  border-radius: 12px; box-shadow: 0 1px 4px rgba(20, 40, 80, .08); padding: 16px 18px 22px;
  font-family: Roboto, "Helvetica Neue", Arial, sans-serif; font-size: 13px;
}
.pp-board:fullscreen { max-width: none; width: 100%; height: 100%; overflow: auto; border-radius: 0; }
.pp-title { font-size: 22px; font-weight: 500; letter-spacing: .01em; text-align: center; margin: 4px 0 2px; }
/* La estrella de favoritos va en el renglón del título, a la derecha y fuera del flujo, para no sumar altura. */
.pp-title-row { position: relative; }
.pp-fav { position: absolute; right: 0; top: 50%; transform: translateY(-50%); margin: 0 !important; }
.pp-fav-sola { display: flex; justify-content: center; }
.pp-board:fullscreen .pp-fav { display: none; }
.pp-sub { text-align: center; color: var(--muted); font-size: 12.5px; margin-bottom: 14px; }

.pp-toolbar { display: flex; align-items: flex-start; gap: 14px; flex-wrap: wrap; padding-top: 8px; }
.pp-filtros { display: flex; align-items: center; gap: 10px; flex: 1 1 0; min-width: 0; flex-wrap: wrap; }
.pp-fecha { flex: 1 1 170px; min-width: 160px; max-width: 240px; }
.pp-multi { flex: 1.3 1 240px; min-width: 200px; position: relative; }
.pp-input {
  flex: 0 1 250px; min-width: 185px; height: 42px; border: 1px solid var(--line); border-radius: 10px; background: #fff;
  display: flex; align-items: center; padding: 0 12px; gap: 8px; color: var(--ink); font-size: 13px; margin: 0;
}
.pp-input:focus-within { border-color: var(--blue); }
.pp-sel { justify-content: space-between; }
.pp-sel .k { font-weight: 600; color: var(--muted); white-space: nowrap; }
.pp-sel select {
  border: 0; outline: 0; background: transparent; font: inherit; font-weight: 600; color: var(--muted);
  width: 100%; min-width: 0; text-align: right; -webkit-appearance: menulist; appearance: menulist;
}
.pp-btn {
  height: 42px; border-radius: 10px; border: 0; padding: 0 16px; font: inherit; font-weight: 600; letter-spacing: .04em;
  text-transform: uppercase; font-size: 12.5px; cursor: pointer; display: inline-flex; align-items: center; gap: 6px;
  white-space: nowrap; flex: 0 0 auto;
}
.pp-btn:disabled { opacity: .55; cursor: default; }
.pp-btn-primary { background: var(--blue); color: #fff; }
.pp-btn-outline { background: #fff; color: var(--blue); border: 1px solid var(--blue); }
.pp-actions { display: flex; align-items: center; gap: 10px; margin-left: auto; }
.pp-disponible { margin: 6px 2px 0; color: var(--muted); font-size: 12px; }

.pp-aviso {
  margin-top: 12px; padding: 10px 14px; border: 1px solid var(--line); border-radius: 10px; background: #fffaf0;
  color: var(--ink); font-size: 13px;
}
.pp-aviso--error { background: #fdecec; color: #8a2b2b; border-color: #f3c9c9; }

.pp-toprow { display: flex; align-items: stretch; gap: 12px; flex-wrap: nowrap; margin-top: 16px; }
.pp-topcard {
  display: flex; align-items: center; gap: 8px 22px; flex-wrap: wrap; background: #fff; border: 1px solid var(--line);
  border-radius: 10px; box-shadow: 0 1px 3px rgba(20, 40, 80, .06); padding: 8px 16px; min-width: 0;
}
.pp-topcard--maq { flex: 1 1 0; min-width: 0; cursor: pointer; transition: border-color .15s, box-shadow .15s; }
.pp-topcard--maq:hover, .pp-topcard--maq:focus-visible { border-color: var(--blue); box-shadow: 0 2px 8px rgba(37, 99, 214, .15); outline: none; }
.pp-topcard--maq.is-on { border-color: var(--blue); background: #f5f9ff; }
.pp-topcard--paro { flex: 1 1 0; min-width: 0; column-gap: 18px; flex-wrap: nowrap; justify-content: space-between; }
.pp-topcard--paro .pp-sec { flex: 0 0 auto; }
.pp-sec { display: flex; flex-direction: column; gap: 4px; }
.pp-sec-head { display: flex; align-items: baseline; gap: 10px; }
.pp-sec-title { color: var(--ink); font-size: 11px; font-weight: 700; line-height: 1.1; text-transform: uppercase; letter-spacing: .03em; white-space: nowrap; }
.pp-sec-title--normal { font-weight: 400; }
.pp-card-hint { color: var(--blue); font-size: 11px; font-weight: 600; white-space: nowrap; margin-left: auto; }
.pp-top3 { display: flex; gap: 18px; flex-wrap: nowrap; overflow: hidden; }
.pp-t3 { display: flex; align-items: baseline; gap: 8px; }
.pp-t3-rank { color: var(--muted); font-size: 12px; font-weight: 700; }
.pp-t3-h { color: var(--kpi); font-size: 18px; font-weight: 800; line-height: 1; font-variant-numeric: tabular-nums; white-space: nowrap; }
.pp-t3-h small { font-size: 11px; font-weight: 600; margin-left: 2px; }
.pp-t3-n { display: flex; flex-direction: column; gap: 2px; }
.pp-t3-nom { color: var(--ink); font-size: 12px; font-weight: 700; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 120px; }
.pp-t3-sub { color: var(--muted-2); font-size: 10px; font-weight: 600; white-space: nowrap; }
.pp-big { font-size: 20px; font-weight: 800; color: var(--ink); line-height: 1; letter-spacing: -.02em; white-space: nowrap; font-variant-numeric: tabular-nums; }
.pp-big small { font-size: 12px; font-weight: 600; color: var(--muted); letter-spacing: 0; margin-left: 3px; }
.pp-pct { font-size: 17px; font-weight: 800; letter-spacing: -.02em; color: var(--kpi); font-variant-numeric: tabular-nums; cursor: help; }
.pp-row-inline { display: flex; align-items: baseline; gap: 10px; }
@media (max-width: 1250px) { .pp-toprow { flex-wrap: wrap; } .pp-topcard--maq, .pp-topcard--paro { flex: 1 1 100%; } }

.pp-legend { display: flex; gap: 18px; flex-wrap: wrap; align-items: center; margin: 14px 2px 4px; }
.pp-lg { display: inline-flex; align-items: center; gap: 7px; font-size: 12.5px; color: var(--muted); }
.pp-lg i { display: inline-block; width: 14px; height: 10px; border-radius: 2px; }
.pp-lg .sw-bar { background: var(--bar); }
.pp-lg .sw-soft { background: var(--bar-soft); }
.pp-lg .sw-line { height: 2px; background: var(--ink); border-radius: 0; }
.pp-lg .sw-guide { height: 0; border-top: 2px dashed var(--guide); border-radius: 0; }

.pp-excl-bar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; margin: 10px 2px 0; }
.pp-excl-lbl { font-size: 12px; font-weight: 600; color: var(--muted); }
.pp-chip { display: inline-flex; align-items: center; gap: 6px; height: 24px; padding: 0 8px 0 10px; border-radius: 12px; font-size: 12px; font-weight: 500; white-space: nowrap; }
.pp-chip--excl { border: 0; cursor: pointer; font-family: inherit; background: #fdecec; color: #8a2b2b; }
.pp-chip--excl .x { color: #8a2b2b; font-weight: 700; }
.pp-excl-reset { border: 0; background: transparent; color: var(--blue); font: inherit; font-size: 12px; font-weight: 600; cursor: pointer; padding: 4px 6px; }

.pp-pareto { border: 1px solid var(--line); border-radius: 12px; background: #fff; margin-top: 12px; overflow: hidden; }
.pp-pareto-head { display: flex; align-items: center; gap: 12px; flex-wrap: wrap; padding: 10px 14px; border-bottom: 1px solid var(--line); background: #fafbfd; }
.pp-hint { color: var(--muted); font-size: 12px; }
.pp-seg { display: inline-flex; background: #eef1f4; border-radius: 999px; padding: 3px; }
.pp-seg--medida { margin-left: auto; }
.pp-seg button { border: 0; background: transparent; font: inherit; font-size: 12px; font-weight: 600; color: var(--muted); padding: 4px 12px; border-radius: 999px; cursor: pointer; }
.pp-seg button[aria-pressed="true"] { background: #fff; color: var(--blue); box-shadow: 0 1px 2px rgba(20, 40, 80, .12); }
.pp-pareto-body { display: grid; grid-template-columns: minmax(380px, 5fr) minmax(320px, 6fr); gap: 0; }
.pp-pareto-body > .pp-tbl-wrap { border-right: 1px solid var(--line); overflow-x: auto; }
.pp-chart-wrap { padding: 12px 14px 8px; min-width: 0; }
/* Dentro de la plataforma el menú lateral quita ancho: en pantallas medianas la tabla gana espacio y se compacta para no necesitar barra de desplazamiento. */
@media (max-width: 1320px) {
  .pp-pareto-body { grid-template-columns: minmax(380px, 11fr) minmax(300px, 9fr); }
  .pp-board thead th, .pp-board tbody td, .pp-board tfoot td { padding-left: 6px; padding-right: 6px; }
  td.name { max-width: 200px; }
}
@media (max-width: 900px) {
  .pp-pareto-body { grid-template-columns: 1fr; }
  .pp-pareto-body > .pp-tbl-wrap { border-right: 0; border-bottom: 1px solid var(--line); }
}
.pp-board table { border-collapse: collapse; width: 100%; font-variant-numeric: tabular-nums; }
.pp-board thead th {
  background: #fff; text-align: right; font-size: 11px; font-weight: 700; color: var(--muted); text-transform: uppercase;
  letter-spacing: .03em; padding: 8px 10px; border-bottom: 1px solid var(--line); white-space: nowrap;
}
.pp-board thead th.l, .pp-board td.l { text-align: left; }
.pp-board tbody td { padding: 6px 10px; text-align: right; border-bottom: 1px solid #f0f2f5; white-space: nowrap; }
.pp-pareto tbody tr { cursor: pointer; }
.pp-pareto tbody tr:hover, .pp-pareto tbody tr.is-hot { background: #eef4fc; }
.pp-pareto tbody tr:focus-visible { outline: 2px solid var(--blue); outline-offset: -2px; }
.pp-pareto tbody tr.in80 td.name { font-weight: 600; }
.pp-pareto tbody tr.in80 td.rank { color: var(--blue); font-weight: 700; }
td.rank { color: var(--muted); width: 28px; }
td.name { max-width: 240px; overflow: hidden; text-overflow: ellipsis; }
td.acc { color: var(--muted); }
.pp-pareto tbody tr.otras td { color: var(--muted); font-style: italic; }
.pp-pareto tbody tr.otras { cursor: default; }
.chk { display: inline-block; width: 12px; height: 12px; border-radius: 3px; margin-right: 8px; vertical-align: -1px; border: 1.5px solid var(--blue); }
.chk--on { background: var(--blue); box-shadow: inset 0 0 0 2px #fff; }
.chk--off { border-color: #b6bec8; background: #fff; }
.chk--na { visibility: hidden; }
.pp-pareto tbody tr.excl td { color: #a3acb6; }
.pp-pareto tbody tr.excl td.name { text-decoration: line-through; }
.pp-pareto tbody tr.sep td { text-align: left; font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: .04em; color: var(--muted); background: #fafbfd; padding: 6px 10px; cursor: default; }
.pp-pareto tbody tr.sep:hover { background: #fafbfd; }
.pp-board tfoot td { padding: 8px 10px; font-weight: 700; text-align: right; border-top: 1px solid var(--line); background: #fafbfd; white-space: nowrap; }
.pp-board tfoot td.l { text-align: left; }
.pp-pareto-foot { padding: 6px 14px 10px; color: var(--muted); font-size: 11.5px; border-top: 1px solid var(--line); }

.pp-chart-wrap svg { width: 100%; height: auto; display: block; overflow: visible; }
.ax { stroke: var(--line); stroke-width: 1; }
.ax-lbl { fill: var(--muted); font-size: 11px; }
.bar-rect { fill: var(--bar); }
.bar-rect.soft { fill: var(--bar-soft); }
.bar-rect.otras { fill: #dfe5ec; }
.bar-rect.is-hot { fill: var(--blue); }
.cum { fill: none; stroke: var(--ink); stroke-width: 2; stroke-linejoin: round; }
.cum-dot { fill: #fff; stroke: var(--ink); stroke-width: 2; }
.guide { stroke: var(--guide); stroke-width: 1.5; stroke-dasharray: 5 4; }
.guide-lbl { fill: var(--guide); font-size: 11px; font-weight: 700; }
.hit { fill: transparent; cursor: pointer; }
.pp-tip {
  position: fixed; pointer-events: none; z-index: 300; background: var(--ink); color: #fff; border-radius: 8px;
  padding: 8px 10px; font-size: 12px; line-height: 1.35; box-shadow: 0 4px 14px rgba(0, 0, 0, .2); max-width: 260px;
}
.pp-tip b { font-weight: 700; }
.pp-tip .m { color: #c9d2dc; }

.pp-abiertos { margin-top: 12px; border: 1px solid var(--line); border-radius: 12px; background: #fff; overflow: hidden; }
.pp-abiertos summary { list-style: none; cursor: pointer; padding: 10px 14px; font-size: 13px; color: var(--ink); display: flex; align-items: center; gap: 8px; background: #fffaf0; }
.pp-abiertos summary::-webkit-details-marker { display: none; }
.pp-abiertos .ab-n { font-weight: 800; color: #9a6400; font-variant-numeric: tabular-nums; }
.pp-abiertos .ab-ver { margin-left: auto; color: var(--blue); font-size: 12px; font-weight: 600; }
.pp-abiertos[open] .ab-ver { visibility: hidden; }
@media (prefers-reduced-motion: reduce) { .pp-board * { transition: none !important; } }
</style>
